<template>
    <div>
        <div class="image-item-wrapper" v-if="!showSelect">
            <CoverPanel
                v-if="!isEditing"
                :noCoverIcon="noCoverIcon"
                :imageUrl="data.cardImage"
                :operateIcons="operateIcons"
                :viewIcon="viewIcon"
                @viewClick="viewHandler"
                @uploadCover="uploadCover"
                @operatorSelect="operatorSelect"
            />
            <AddRefCoverPanel
                v-if="isEditing"
                class="item-cover"
                :needClip="needClip"
                :alwayShowCancel="isEditing && this.data.cardImage"
                :aspectRatio="16 / 9"
                @change="coverChange"
                @cancel="coverCancel"
            />
            <IconInput class="image-item-input" :placeholder="inputDescLabel" :initValue="data.name" @inputChange="descChange" />
            <HotPointPanel :data="hotPointData" @redSwitch="redSwitch" @hotSwitch="hotSwitch" @endDateChange="hotDateChange" />
            <TransferIcon class="opr-transfer" @transfer="tranferItem" />
            <DeleteIcon class="opr-delete" @iconClick="deleteItem" />
        </div>
        <div class="item-selected" @mouseover="onMouseover" @mouseout="onMouseOut" v-else>
            <SelectItem :itemData="itemData" @itemSelect="selectItemType" />
            <DeleteIcon v-show="showDelete" class="opr-delete" @iconClick="deleteItemVideo" />
        </div>
    </div>
</template>

<script>
import TransferIcon from "@/views/zhiji/bComponents/icons/TransferIcon";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import HotPointPanel from "../HotPointPanel";
import CoverPanel from "@/views/zhiji/components/coverPanel/CoverPanel";
import SelectItem from "@/views/zhiji/components/coverPanel/SelectItem";
import AddRefCoverPanel from "@/views/zhiji/components/coverPanel/AddRefCoverPanel.vue";

import { isArray, isObject } from "@/views/zhiji/js/common/util.js";

export default {
    name: "ImageItem",
    props: ["data", "parentUId"],
    components: {
        TransferIcon,
        DeleteIcon,
        IconInput,
        HotPointPanel,
        CoverPanel,
        SelectItem,
        AddRefCoverPanel
    },
    data() {
        return {
            viewIcon: {
                position: "-110px -85px"
            },
            showSelect: true,
            showDelete: false,
            isEditing: false,
            isEditCover: false,
            needClip: false,
        };
    },
    computed: {
        hotPointData() {
            return {
                redState: this.data.redState,
                hotItem: this.data.hotItem,
                endTime: this.data.redHotEndTime
            };
        },
        inputDescLabel() {
            return this.$t("zhiji.answer.inputDesc");
        },
        noCoverIcon() {
            return {
                position: "-145px -50px",
                label: this.$t("zhiji.answer.addPicture")
            };
        },
        operateIcons() {
            return [
                {
                    type: "updateImage",
                    position: "-38px -77px",
                    name: this.$t("zhiji.materialLibrary.replacePic")
                },
                {
                    type: "updateCover",
                    position: "-38px -77px",
                    name: this.$t("zhiji.answer.replaceCover"),
                    noCoverName: this.$t("zhiji.answer.addCover"),
                    noCoverPosition: "-296px 1px"
                }
            ];
        },
        itemData() {
            return [
                {
                    type: "reference",
                    position: "-383px -1px",
                    name: this.$t("zhiji.answer.reference"),
                    iconClass: "reference-icon"
                },
                {
                    type: "create",
                    position: "-198px -50px",
                    name: this.$t("zhiji.answer.create")
                }
            ];
        }
    },
    mounted() {
        this.data.resourceId && this.data.cardImage && (this.showSelect = false);
    },
    methods: {
        tranferItem(event) {
            this.zhiji.dragStart(event, "h-list-item", "h", newIdx => {
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "tranferContentItem",
                    widget: {
                        uId: this.parentUId,
                        item: {
                            newIdx: newIdx,
                            uId: this.data.uId
                        }
                    }
                });
            });
        },
        deleteItemVideo() {
            this.deleteItemHandle();
            this.$emit("deleteItem");
        },
        deleteItemHandle() {
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "deleteContentItem",
                widget: {
                    uId: this.parentUId,
                    item: {
                        uId: this.data.uId
                    }
                }
            });
        },
        selectItemType(item) {
            let handler = {
                reference: this.referenceEdit,
                create: this.manualEdit
            };
            handler[item.type].call(null);
        },
        referenceEdit() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "image",
                    confirm: result => {
                        let updateData = "";
                        !isArray(result) && isObject(result) ? (updateData = result) : (updateData = result[0]);
                        let addData = isArray(result) && result.slice(1);
                        this.commitUpdate({
                            resourceId: updateData.id,
                            cardImage: updateData.url,
                            image: updateData.url,
                            name: updateData.title
                        });
                        isArray(result) && this.addContentItem(addData);
                        this.showSelect = false;
                        this.$emit("selectClick", this.data);
                    }
                }
            });
        },
        manualEdit() {
            this.$store.dispatch("zhiji/showModal", {
                type: "PictureEditModel",
                data: {
                    type: "add",
                    pictureData: {},
                    childModel: true,
                    confirm: data => {
                        this.commitUpdate({
                            resourceId: data.id,
                            cardImage: data.url,
                            image: data.url,
                            url: "",
                            name: data.title
                        });
                        this.showSelect = false;
                        this.$emit("selectClick", this.data);
                    }
                }
            });
        },
        addContentItem(data) {
            data.forEach(item => {
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "addContentItem",
                    widget: {
                        uId: this.parentUId,
                        item: {
                            type: "image",
                            cardImage: item.url,
                            image: item.url,
                            url: "",
                            name: item.title,
                            resourceId: item.id
                        }
                    }
                });
            });
        },
        deleteItem() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.answer.delCardTips"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.commit("zhiji/editQsUpdateAnswer", {
                            type: "deleteContentItem",
                            widget: {
                                uId: this.parentUId,
                                item: {
                                    uId: this.data.uId
                                }
                            }
                        });
                        this.showSelect = true;
                    }
                }
            });
        },
        descChange(newVal) {
            this.commitUpdate({
                name: newVal
            });
        },
        redSwitch(redState) {
            this.commitUpdate({
                redState: redState
            });
        },
        hotSwitch(hotItem) {
            this.commitUpdate({
                hotItem: hotItem
            });
        },
        hotDateChange(dateStr) {
            this.commitUpdate({
                redHotEndTime: dateStr
            });
        },
        viewHandler() {
            this.$store.commit("zhiji/showModal", {
                type: "ImageViewModal",
                data: {
                    url: this.data.image
                }
            });
        },
        uploadCover() {
            // 添加图片
            this.uploadImage(false, imageUrl => {
                this.commitUpdate({
                    image: imageUrl,
                    cardImage: "none"
                });
            });
        },
        operatorSelect(type) {
            if (type == "updateCover") {
                this.isEditCover = true;
                this.needClip = true;
            } else if (type == "updateImage") {
                this.isEditCover = false;
            }
            this.isEditing = true;
        },
        commitUpdate(updateData) {
            updateData.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContentItem",
                widget: {
                    uId: this.parentUId,
                    item: updateData
                }
            });
        },
        onMouseover() {
            this.showDelete = true;
        },
        onMouseOut() {
            this.showDelete = false;
        },
        uploadImage(needClip, cb) {
            this.$store.commit("zhiji/showModal", {
                type: "ImageClipModal",
                data: {
                    openFile: openFile => {
                        this.openFile = openFile;
                    },
                    confirm: url => {
                        cb && cb(url);
                    },
                    cancel: () => {
                        this.openFile = null;
                    },
                    needClip: needClip,
                    aspectRatio: 16 / 9
                }
            });

            // 打开组件时弹出文件选择，只有在isTrusted事件里面可以触发, HACK
            setTimeout(() => {
                this.openFile();
                this.openFile = null;
            }, 500);
        },
        coverChange({ value }) {
            if (value) {
                this.isEditCover
                    ? this.commitUpdate({
                          cardImage: value})
                    : this.commitUpdate({
                          image: value,
                          cardImage: value,
                      })
            }
            this.isEditCover = false;
            this.isEditing = false;
            this.needClip = false;
        },
        coverCancel() {
            this.isEditCover = false;
            this.isEditing = false;
            this.needClip = false;
        },
    }
};
</script>

<style lang="less" scoped>
.image-item-wrapper {
    position: relative;
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 14px;
    flex-shrink: 0;
    width: 200px;

    .opr-transfer {
        display: none;
        z-index: 1;
        top: -21px;
        left: -2px;
        position: absolute;
    }

    .opr-delete {
        display: none;
        z-index: 1;
        right: -9px;
        top: -9px;
        position: absolute;
    }

    &:hover {
        .opr-transfer {
            display: inline-flex;
        }

        .opr-delete {
            display: inline-block;
        }
    }
    .item-cover {
        width: 200px;
        height: 150px;
        border: none;
    }
}

.item-selected {
    position: relative;

    .opr-delete {
        position: absolute;
        top: -9px;
        right: 9px;
    }
}
</style>
